// extracted by mini-css-extract-plugin
export default {"ReposCountText":"ReposList-module__ReposCountText__L2Hp1ey","ReposListContainer":"ReposList-module__ReposListContainer__XQa5ZDy"};